import { parseZonedDateTime } from '@rematter/common/dateTime';

import { NotificationFeedEntry } from '~/modules/notifications/types';
import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const notificationFeedQueryAtom = createQueryAtomFactory(
  'notifications.feed',
  (params: { cursor?: { afterId: string }; limit?: number }) => ({
    notificationFeed: {
      __args: {
        channel: 'in_app' as const,
        cursor: params.cursor,
        limit: params.limit ?? 20,
      },
      entries: {
        id: true,
        notification: {
          id: true,
          eventId: true,
          notificationTypeKey: true,
          actorId: true,
          resourceType: true,
          resourceId: true,
          title: true,
          body: true,
          actionLink: true,
        },
        channel: true,
        isRead: true,
        isSeen: true,
        isArchived: true,
        readAt: true,
        seenAt: true,
        timestamps: {
          createdAt: true,
        },
      },
      hasMore: true,
    },
  }),
  {
    select: (data) => ({
      entries:
        data?.notificationFeed?.entries?.map(
          (entry): NotificationFeedEntry => ({
            id: entry.id,
            notification: {
              id: entry.notification.id,
              eventId: entry.notification.eventId,
              notificationTypeKey: entry.notification.notificationTypeKey,
              actorId: entry.notification.actorId ?? undefined,
              resourceType: entry.notification.resourceType,
              resourceId: entry.notification.resourceId,
              title: entry.notification.title,
              body: entry.notification.body,
              actionLink: entry.notification.actionLink ?? undefined,
            },
            channel: entry.channel,
            isRead: entry.isRead,
            isSeen: entry.isSeen,
            isArchived: entry.isArchived,
            readAt: entry.readAt ? parseZonedDateTime(entry.readAt) : undefined,
            seenAt: entry.seenAt ? parseZonedDateTime(entry.seenAt) : undefined,
            createdAt: parseZonedDateTime(entry.timestamps.createdAt),
          }),
        ) ?? [],
      hasMore: data?.notificationFeed?.hasMore ?? false,
    }),
    keepPreviousData: true,
  },
);
